/**
 * Combina las dos fuentes de progresión permanente (mejoras compradas +
 * gear equipado) en un único punto de entrada para armar el `RunState`
 * inicial de una run nueva. Lo usa la escena Lobby al pulsar PELEAR (y,
 * eventualmente, el integrador de GameScene en F2).
 */

import type { MetaState, RunState } from '../core/types';
import { applyGearToRunState } from './gear';
import { applyUpgradesToRunState } from './upgrades';

/** Aplica mejoras permanentes + bonos de gear equipado al RunState inicial de una run nueva. */
export function applyMetaProgressionToRunState(runState: RunState, meta: MetaState): RunState {
  const withUpgrades = applyUpgradesToRunState(runState, meta);
  return applyGearToRunState(withUpgrades, meta);
}
